import {
    createAppointment,
    editAppointment,
    getAppointment,
    getAppointmentById,
    deleteAppointment,
    setAppointmentStatus,
    appointmentRepeat,
    appendSignatureToAppmt,
    bulkAssignSignature,
    editAppointmentPosition,
    saveCurrentLocation,
    getStaffClients,
    removeStaffClients,
    changeApptLockUnlock,
    manageNotes,
    connectReconnect,
    cancelAppt,
    deleteAllAppt,
    removeApptFromBill,
    removeApptFromInvoice,
    unRenderAppt,
    getApptStaffs,
    appointmentFromTemplate,
    uploadApptDocument,
    editApptDocument,
    getApptDocument,
    deleteApptDocument,
    getAppointmentInfo,
    editCancelReason,
    getAppointmentByFilters,
    removeAppointmentById,
    deleteSignature,
    getAppointmentDates,
    removeAppointmentDates,
    refreshErrors,
    addApptLink,
    deleteApptNote,
    addEditApptNote,
    changeApptUnits,
    deleteMassAppt,
    removeAppointmentInfo,
    requestApptNote,
    remindApptNote,
    completeMassAppts,
    checkEligibility,
    unCancelAppt,
    getApptDataCollection,
    getCalendarAppointment, remindApptSignature,
    getApptAddresses,
    removeApptAddresses,
    getEligibleChargeRates,
    removeEligibleChargeRates,
} from './appointment.action';
import moment from 'moment';

export { appointmentReducer } from './appointment.reducer';
export { watchAppointments } from './appointment.saga';

export const appointmentActions = {
    /** Create, Edit Appointment */
    createAppointment,
    editAppointment,
    addApptLink,
    editAppointmentPosition,
    changeApptLockUnlock,
    changeApptUnits,
    /** end */

    /** Get Appointment */
    getAppointment,
    getCalendarAppointment,
    getAppointmentById,
    getAppointmentDates,
    removeAppointmentDates,
    removeAppointmentById,
    getAppointmentInfo,
    removeAppointmentInfo,
    getAppointmentByFilters,
    getApptDataCollection,
    getApptAddresses,
    removeApptAddresses,
    getEligibleChargeRates,
    removeEligibleChargeRates,
    /** end */

    /** Delete Appointment */
    deleteAppointment,
    deleteMassAppt,

    /** end */

    /** Appointment Status */
    setAppointmentStatus,
    removeApptFromBill,
    removeApptFromInvoice,
    unRenderAppt,
    editCancelReason,
    completeMassAppts,
    /** end */

    /** Appointment Repeat */
    appointmentRepeat,
    appointmentFromTemplate,
    /** end */

    appendSignatureToAppmt,
    bulkAssignSignature,
    deleteSignature,
    saveCurrentLocation,
    getStaffClients,
    removeStaffClients,
    manageNotes,
    connectReconnect,
    cancelAppt,
    unCancelAppt,
    deleteAllAppt,
    getApptStaffs,
    /** Appt Documents */
    uploadApptDocument,
    editApptDocument,
    getApptDocument,
    deleteApptDocument,
    /** end */
    refreshErrors,
    addEditApptNote,
    deleteApptNote,
    requestApptNote,
    remindApptNote,
    remindApptSignature,
    /** Eligibility */
    checkEligibility,
};

export const filteredArray = (appointments) => {
    const arr = [];
    appointments.map((i) => i?.data?.forEach((k) => arr.push(k)));
    return arr;
};

export const handleReorderCategory = (body, id, fullList) => {
    const allList = [...fullList];
    let pos = fullList.map((val) => val?.id).indexOf(id);
    allList[pos].startDate = moment.utc(body.startDate).format();
    allList[pos].startTime = moment.utc(body.startTime).format();
    allList[pos].endTime = moment.utc(body.endTime).format();
    return allList;
};

export const deleteAppt = (list, id) => {
    return list?.filter((i) => (i?._id || i?.id) !== id);
};
